import { pathsMatch } from "@pathwright/ux/src/components/link/Link"
import { getRelativeRoute } from "../../utils/urls"

export function isInFlowOrderConversion(order: {
  order_data?: {
    redirect_to?: string | null
    cancel_url?: string | null
  } | null
}) {
  const redirectTo = order.order_data?.redirect_to
  const cancelUrl = order.order_data?.cancel_url

  return !!(
    redirectTo &&
    cancelUrl &&
    pathsMatch(
      getRelativeRoute(cancelUrl).pathname,
      getRelativeRoute(redirectTo).pathname
    )
  )
}
